@if (month) {
    <div class="widget-month">
        <div class="widget-header d-flex justify-content-between align-items-center">
            <div class="invisible">d</div>
            <div style="text-transform: uppercase; font-size: 120%;">{{ month.name }} @if (month.year !== now.year()) {
                <span>({{ month.year }})</span>
            }</div>
            <div style="cursor: pointer; user-select: none; margin-right: 5px;">
                <i class="fa fa-caret-left fa-2x" (click)="previousMonth()"></i>
                <i class="fa fa-caret-right fa-2x" (click)="nextMonth()" style="margin-left: 5px;"></i>
            </div>
        </div>
        <div class="month-wrapper">
            <table class="month-table">
                <thead>
                    <tr class="widget-grid-header">
                        <th>S</th>
                        <th>M</th>
                        <th>T</th>
                        <th>W</th>
                        <th>T</th>
                        <th>F</th>
                        <th>S</th>
                    </tr>
                </thead>
                <tbody>
                    @for (week of month.weeks; track week; let i = $index) {
                        <tr class="week-row">
                            @for (day of week.days; track day; let j = $index) {
                                <td
                                    [class.actual-day]="day.monthDay"
                                    [class.no-day]="!day.monthDay"
                                    [class.first-week]="i === 0"
                                    [class.last-week]="i === month.weeks.length - 1"
                                    [class.clicked-day]="clickedDay && clickedDay.monthDay && day.monthDay === clickedDay.monthDay"
                                    [class.today]="isDayToday(day)"
                                    [popover]="eventsPopover"
                                    container="body"
                                    [placement]="getPopoverPlacement(i,j)"
                                    [outsideClick]="true"
                                    (onHidden)="clickedDay = undefined"
                                    (click)="dayClicked(day)">
                                    <div>
                                        <strong>{{ day.monthDay }}</strong>
                                    </div>
                                    <div>
                                        @for (iconClass of day.icons; track iconClass) {
                                            <span><i [class]="iconClass"></i> </span>
                                        }
                                        @if (!day.eventTypeBlocks) {
                                            <span class="invisible"><i class="fa fa-gavel small-icon-badge"></i></span>
                                        }
                                    </div>
                                </td>
                            }
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <div style="margin-top: 5px;">
            @for (legendBlock of legendBlocks; track legendBlock) {
                <a
                    style="padding: 1px 5px; margin-right: 5px; display: inline-block; cursor: pointer; min-width: 12em;"
                    [class]="getBackgroundColor(legendBlock.dashboardCalendarEventType)"
                    (click)="legendClicked(legendBlock)"
                    (onHidden)="clickedDay = undefined"
                    [popover]="eventsPopover"
                    container="body"
                    placement="top"
                    [outsideClick]="true">
                    <i [class]="getIconClass(legendBlock.dashboardCalendarEventType)"></i> {{ legendBlock.count | number }} {{ legendBlock.title }}@if (legendBlock.count > 1) {
                    <span>s</span>
                }
                </a>
            }
        </div>
    </div>
}

<ng-template #eventsPopover>
    @if (clickedDay) {
        <div>
            <i class="fa fa-spinner fa-pulse fa-3x text-center" [hidden]="!loading"></i>
            <div class="d-flex" [hidden]="loading">
                @if (clickedDay.monthDay) {
                    <div class="text-center">
                        <div><strong>{{ clickedDay.weekdayAbbr }}</strong></div>
                        <div class="fw-bold">{{ clickedDay.monthDay }}</div>
                    </div>
                }
                <div class="w-100 ms-3">
                    @for (eventTypeBlock of clickedDay.eventTypeBlocks; track eventTypeBlock) {
                        <div class="d-flex"
                             [class]="getBackgroundColor(eventTypeBlock.dashboardCalendarEventType)">
                            <div><i [class]="getIconClass(eventTypeBlock.dashboardCalendarEventType)"></i></div>
                            <div class="ps-2">
                                <a (click)="goToSmartFromPopover(eventTypeBlock)">
                                    <span>{{ eventTypeBlock.totalCount | number }}</span>
                                    <span>{{ getEventTypeTitle(eventTypeBlock.dashboardCalendarEventType, true) }}@if (eventTypeBlock.totalCount > 1) {
                                        <span>s</span>
                                    }</span>
                                </a>
                                <div>
                                    (@for (event of eventTypeBlock.events; track event; let i = $index) {
                                    <span
                                        (click)="goToSmartFromPopover(eventTypeBlock, event.stateAbbr)">
                                        <a class="clickable">{{ event.count | number }} {{ event.stateAbbr }}</a>
                                        @if (i < eventTypeBlock.events.length - 1) {
                                            <span>, </span>
                                        }
                                    </span>
                                })
                                </div>
                            </div>
                        </div>
                    }
                    @if (!clickedDay.eventTypeBlocks) {
                        <div>
                            <em>No events this day</em>
                        </div>
                    }
                </div>
            </div>
        </div>
    }
</ng-template>
